import React from 'react';

import { TimeInput } from '@gogame/components';

import { omitFormProps } from '../utils';
import withFormField from './withFormField';

export default withFormField({
  debounceTimeout: 300,
})(({ area, ...props }) => {
  return <TimeInput {...omitFormProps(props)} />;
});
